import { isNullOrUndefined } from "../../../../../../../../tools";
import { IdProvider } from "../../../../../../../services/idprovider.service";
import { ServerCommunicatorService } from "../../../../../../../services/server-communicator.service";
import { UIUtils } from "../../../../../../../services/uiutils.service";
import { Utils } from "../../../../../../../services/utils.service";
import { DataContainer } from "../../../../../../infrastructure/datacontainer";
import { DataContainerService } from "../../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../../infrastructure/enums";
import { IPersistable } from "../../../../../../infrastructure/IPersistable";
import { PayloadPacketFacade } from "../../../../../../infrastructure/payloadpacket/payloadpacketfacade";
import { TransportData } from "../../../../../../infrastructure/transportdata";
import { ValidationResultAccumulator } from "../../../../../../infrastructure/validationresultaccumulator";
import { ValidationMessages, ValidationPatterns } from "../../../../../constants";
import { TrainingVideoFetchRequest } from "./trainingvideofetchrequest";

export class TrainingVideoProps {

 public created_date: string = '';
  public updated_date: string = '';
  public created_by: number = 0;
  public updated_by: number = 0;

  public id: number = 0;
  public description_mr: string = '';
  public description_en: string = '';
  public link: string = '';

  public readonly is_newly_created: boolean = false;


  private constructor(IsNewlyCreated: boolean) {
    this.is_newly_created = IsNewlyCreated;
  }

  public static Blank() {
    return new TrainingVideoProps(true);
  }
}

export class TrainingVideo implements IPersistable<TrainingVideo> {
  public static readonly mastertablename: string = 'training_video_master';

  private constructor(public readonly p: TrainingVideoProps, public readonly AllowEdit: boolean) {

  }

  public async EnsurePrimaryKeysWithValidValues(): Promise<void> {
    if (this.p.id === undefined || this.p.id === 0) {
      const newids = await IdProvider.GetInstance().GetNextEntityId();
      // const newids = await IdProvider.GetInstance().GetAllocateSingleIds();
      this.p.id = newids[0];
      if (this.p.id <= 0) throw new Error("Cannot assign Id. Please try again");
    }
  }

  public GetEditableVersion(): TrainingVideo {
    let newTrainingVideo: TrainingVideoProps = Utils.GetInstance().DeepCopy(this.p);
    return TrainingVideo.CreateInstance(newTrainingVideo, true);
  }

  public static CreateNewInstance() {
    return new TrainingVideo(TrainingVideoProps.Blank(), true);
  }

  public static CreateInstance(data: any, allowEdit: boolean) {
    return new TrainingVideo(data as TrainingVideoProps, allowEdit);
  }

  public CheckSaveValidity(_td: TransportData, vra: ValidationResultAccumulator): void {
    if (!this.AllowEdit) vra.add('', 'This object is not editable and hence cannot be saved.');
    if (!this.p.description_en || this.p.description_en.trim() == '') {
      vra.add('description_en', 'Description cannot be blank. ');
    }
    if (!this.p.description_mr || this.p.description_mr.trim() == '') {
      vra.add('description_mr', 'Description cannot be blank. ');
    }
    // if (this.p.TrainingVideoRef <= 0) vra.add('TrainingVideoRef', 'TrainingVideo cannot be blank. ');
    // if (this.p.CityRef <= 0) vra.add('CityRef', 'City cannot be blank. ');
  }

  public MergeIntoTransportData(td: TransportData) {
    DataContainerService.GetInstance().MergeIntoContainer(td.MainData, TrainingVideo.mastertablename, this.p);
  }

  private static m_currentInstance: TrainingVideo = TrainingVideo.CreateNewInstance();

  public static GetCurrentInstance() {
    return TrainingVideo.m_currentInstance;
  }

  public static SetCurrentInstance(value: TrainingVideo) {
    TrainingVideo.m_currentInstance = value;
  }

  // ********************************************
  public static cacheDataChangeLevel: number = -1;

  public static SingleInstanceFromTransportData(td: TransportData): TrainingVideo {
    let dcs = DataContainerService.GetInstance();
    if (dcs.CollectionExists(td.MainData, TrainingVideo.mastertablename)) {
      for (let data of dcs.GetCollection(td.MainData, TrainingVideo.mastertablename)!.Entries) {
        return TrainingVideo.CreateInstance(data, false);
      }
    }

    return null as any;
  }

  public static ListFromDataContainer(cont: DataContainer,
    filterPredicate: (arg0: any) => boolean = null as any,
    sortPropertyName: string = "Name"): TrainingVideo[] {
    let result: TrainingVideo[] = [];

    let dcs = DataContainerService.GetInstance();

    if (dcs.CollectionExists(cont, TrainingVideo.mastertablename)) {
      let coll = dcs.GetCollection(cont, TrainingVideo.mastertablename)!;
      let entries = coll.Entries;

      if (!isNullOrUndefined(filterPredicate)) entries = entries.filter(filterPredicate);

      if (sortPropertyName.trim().length > 0) {
        entries = Utils.OrderByPropertyName(entries, sortPropertyName);
      }

      for (let data of entries) {
        result.push(TrainingVideo.CreateInstance(data, false));
      }
    }

    return result;
  }

  public static ListFromTransportData(td: TransportData): TrainingVideo[] {
    return TrainingVideo.ListFromDataContainer(td.MainData);
  }

  public static async FetchTransportData(req: TrainingVideoFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = req.FormulateTransportData();
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
      return null;
    }

    let tdResponse = JSON.parse(tr.Tag) as TransportData;
    return tdResponse;
  }

  public static async FetchTransportDataWithoutLoginToken(req: TrainingVideoFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = req.FormulateTransportData();
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequestWithoutLoginToken(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
      return null;
    }

    let tdResponse = JSON.parse(tr.Tag) as TransportData;
    return tdResponse;
  }

  // Function created For Trasaction Service filters 
  public static async FetchTransportDataForTransactionFilter(req: TrainingVideoFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = req.FormulateTransportData();
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
      return null;
    }

    let tdResponse = JSON.parse(tr.Tag) as TransportData;
    return tdResponse;
  }

  public static async FetchInstance(id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new TrainingVideoFetchRequest();
    req.training_video_ids.push(id);

    let tdResponse = await TrainingVideo.FetchTransportData(req, errorHandler) as TransportData;
    return TrainingVideo.SingleInstanceFromTransportData(tdResponse);
  }

  public static async FetchList(req: TrainingVideoFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdResponse = await TrainingVideo.FetchTransportData(req, errorHandler) as TransportData;
    return TrainingVideo.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireList(errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new TrainingVideoFetchRequest();
    let tdResponse = await TrainingVideo.FetchTransportData(req, errorHandler) as TransportData;
    return TrainingVideo.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireListWithoutLogintoken(errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new TrainingVideoFetchRequest();
    let tdResponse = await TrainingVideo.FetchTransportDataWithoutLoginToken(req, errorHandler) as TransportData;
    return TrainingVideo.ListFromTransportData(tdResponse);
  }


  public static async FetchEntireListByStateRef(state_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new TrainingVideoFetchRequest();
    req.state_ids.push(state_id)
    let tdResponse = await TrainingVideo.FetchTransportData(req, errorHandler) as TransportData;
    return TrainingVideo.ListFromTransportData(tdResponse);
  }

  // get all asha for Trasaction filter service file 
  public static async FetchEntireListForTransactionFilter(errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new TrainingVideoFetchRequest();
    let tdResponse = await TrainingVideo.FetchTransportDataForTransactionFilter(req, errorHandler) as TransportData;
    return TrainingVideo.ListFromTransportData(tdResponse);
  }


  public async DeleteInstance(successHandler: () => Promise<void> = null!, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = new TransportData();
    tdRequest.RequestType = RequestTypes.Deletion;

    this.MergeIntoTransportData(tdRequest);
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
    }
    else {
      if (!isNullOrUndefined(successHandler)) await successHandler();
    }
  }

}
